import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "La Filosofía",
    body: "Devolvemos al cuidado dental su dimensión más humana: sin salas de espera, sin luces frías. Solo tu casa, tu ritmo y una profesional que conoce tu boca.",
  },
  {
    n: "02",
    title: "El Proceso",
    body: "Cada visita comienza con una entrevista breve, sigue con una limpieza precisa mediante ultrasonidos y termina con pautas personalizadas por escrito.",
  },
  {
    n: "03",
    title: "El Cuidado",
    body: "Un vínculo continuo. Recordatorios, seguimiento y una relación de confianza que trasciende la consulta puntual.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifiesto" data-testid="manifesto-section" className="relative py-24 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-12 gap-6 md:gap-8 mb-16 md:mb-24"
        >
          <div className="col-span-12 md:col-span-4 text-xs md:text-sm uppercase tracking-[0.28em] text-[color:var(--text-secondary)]">
          </div>
          <h2 className="col-span-12 md:col-span-8 font-heading text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]">
            Tres capítulos <em className="italic text-[color:var(--accent)]">esenciales</em> sobre cómo entendemos la higiene dental.
          </h2>
        </motion.div>

        <div className="grid grid-cols-12 gap-y-12 md:gap-y-0 border-t border-[color:var(--border-subtle)]">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.85, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className={`col-span-12 md:col-span-4 relative py-10 md:py-16 md:px-10 ${i > 0 ? "md:border-l" : ""} border-[color:var(--border-subtle)]`}
              data-testid={`chapter-${c.n}`}
            >
              <span className="absolute -top-1 right-2 md:right-6 font-heading text-6xl md:text-7xl leading-none text-[color:var(--signature-dark)]/15 select-none pointer-events-none">
                {c.n}
              </span>
              <div className="relative">
                <div className="font-mono text-xs tracking-widest text-[color:var(--accent)] mb-4">— {c.n}</div>
                <h3 className="font-heading text-3xl md:text-4xl tracking-tight mb-4">{c.title}</h3>
                <p className="text-[color:var(--text-secondary)] leading-relaxed max-w-sm">{c.body}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
